import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
/**
 * Common component to render a placeholder system note.
 *
 * @example
 * <placeholder-system-note
 *  :note="{ body: 'Commands are being applied'}"
 *  />
 */ export default {
    name: 'PlaceholderSystemNote',
    components: {
        TimelineEntryItem
    },
    props: {
        note: {
            type: Object,
            required: true
        }
    }
};
